const CorporateActionSource = Object.freeze({
  ANNOUNCEMENT: "ANNOUNCEMENT",
  USER: "USER",
});

export default CorporateActionSource;
